import type { CatalogCategoryNode } from '../types/catalog';

/**
 * Estructura principal y completa para el catálogo de productos de CR-Seg-Ind.
 * Define las 10 categorías principales y sus subcategorías técnicas.
 */
export const catalogStructure: CatalogCategoryNode[] = [
  {
    id: 'epp',
    name: 'EPP (Equipos de Protección Personal)',
    children: [
      {
        id: 'epp-auditiva',
        name: 'Protección Auditiva',
        children: [
          { id: 'auditiva-copa', name: 'Copa' },
          { id: 'auditiva-endoaural', name: 'Endoaural' }
        ]
      },
      {
        id: 'epp-craneana',
        name: 'Protección Craneana',
        children: [
          { id: 'craneana-cascos', name: 'Cascos' },
          { id: 'craneana-accesorios', name: 'Accesorios' }
        ]
      },
      {
        id: 'epp-facial',
        name: 'Protección Facial',
        children: [
          { id: 'facial-protectores', name: 'Protectores Faciales' },
          { id: 'facial-accesorios', name: 'Accesorios' }
        ]
      },
      {
        id: 'epp-ocular',
        name: 'Protección Ocular',
        children: [
          { id: 'ocular-anteojos', name: 'Anteojos' },
          { id: 'ocular-antiparras', name: 'Antiparras' },
          { id: 'ocular-recetados', name: 'Recetados' }
        ]
      },
      {
        id: 'epp-respiratoria',
        name: 'Protección Respiratoria',
        children: [
          { id: 'respiratoria-desechables', name: 'Desechables' },
          { id: 'respiratoria-reutilizables', name: 'Reutilizables' },
          { id: 'respiratoria-autonomos', name: 'Equipos Autónomos' }
        ]
      },
      {
        id: 'epp-manos',
        name: 'Protección de Manos',
        children: [
          { id: 'manos-descartables', name: 'Descartables' },
          { id: 'manos-latex', name: 'Látex' },
          { id: 'manos-nitrilo', name: 'Nitrilo' },
          { id: 'manos-pvc', name: 'PVC' },
          { id: 'manos-anticorte', name: 'Anticorte' },
          { id: 'manos-temperatura', name: 'Temperatura' },
          { id: 'manos-tejidos', name: 'Tejidos' },
          { id: 'manos-dielectricos', name: 'Dieléctricos' }
        ]
      }
    ]
  },
  {
    id: 'indumentaria',
    name: 'Indumentaria',
    children: [
      { id: 'indumentaria-ropa-trabajo', name: 'Ropa de Trabajo' },
      { id: 'indumentaria-abrigo', name: 'Abrigo' },
      { id: 'indumentaria-lluvia', name: 'Ropa para Lluvia' },
      { id: 'indumentaria-delantales', name: 'Delantales' },
      { id: 'indumentaria-descartables', name: 'Descartables' },
      { id: 'indumentaria-quimica', name: 'Protección Química' },
      { id: 'indumentaria-soldadura', name: 'Soldadura' },
      { id: 'indumentaria-ignifuga-arco', name: 'Ignífuga / Arco Eléctrico' }
    ]
  },
  {
    id: 'calzado',
    name: 'Calzado de Seguridad',
    children: [
      { id: 'calzado-zapatos', name: 'Zapatos' },
      { id: 'calzado-botines', name: 'Botines' },
      { id: 'calzado-zapatillas', name: 'Zapatillas' },
      { id: 'calzado-botas', name: 'Botas' },
      { id: 'calzado-visita', name: 'Calzado de Visita' },
      { id: 'calzado-suecos', name: 'Suecos' }
    ]
  },
  {
    id: 'altura',
    name: 'Trabajo en Altura',
    children: [
      { id: 'altura-arneses', name: 'Arneses' },
      { id: 'altura-colas-amarre', name: 'Colas de Amarre' },
      { id: 'altura-retractiles', name: 'Retráctiles' },
      { id: 'altura-lineas-vida', name: 'Líneas de Vida' },
      { id: 'altura-accesorios', name: 'Accesorios' }
    ]
  },
  {
    id: 'izaje',
    name: 'Izaje y Sujeción de Cargas',
    children: [
      { id: 'izaje-equipos', name: 'Izaje' },
      { id: 'izaje-eslingas', name: 'Eslingas' },
      { id: 'izaje-cintas-crique', name: 'Cintas con Crique' }
    ]
  },
  {
    id: 'senalizacion',
    name: 'Señalización',
    children: [
      { id: 'senalizacion-conos', name: 'Conos' },
      { id: 'senalizacion-cadenas', name: 'Cadenas' },
      { id: 'senalizacion-delineadores-postes', name: 'Delineadores / Postes' },
      { id: 'senalizacion-mallas', name: 'Mallas' },
      { id: 'senalizacion-cintas', name: 'Cintas' },
      { id: 'senalizacion-vehicular', name: 'Señalización Vehicular' },
      { id: 'senalizacion-carteleria', name: 'Cartelería' }
    ]
  },
  {
    id: 'emergencia',
    name: 'Emergencia y Primeros Auxilios',
    children: [
      { id: 'emergencia-botiquines', name: 'Botiquines' },
      { id: 'emergencia-duchas', name: 'Duchas de Emergencia' },
      { id: 'emergencia-lavaojos', name: 'Lavaojos' },
      { id: 'emergencia-luces', name: 'Luces de Emergencia' }
    ]
  },
  {
    id: 'bloqueo',
    name: 'Bloqueo y Seguridad',
    children: [
      { id: 'bloqueo-sistemas', name: 'Sistemas de Bloqueo' },
      { id: 'bloqueo-candados', name: 'Candados' },
      { id: 'bloqueo-estaciones-armarios', name: 'Estaciones / Armarios' },
      { id: 'bloqueo-accesorios', name: 'Accesorios' }
    ]
  },
  {
    id: 'derrames-limpieza',
    name: 'Derrames y Limpieza',
    children: [
      { id: 'derrames-absorbentes', name: 'Absorbentes' },
      { id: 'derrames-panos', name: 'Paños de Limpieza' },
      { id: 'derrames-recipientes', name: 'Recipientes' }
    ]
  },
  {
    id: 'accesorios',
    name: 'Accesorios',
    children: [
      { id: 'accesorios-cutters', name: 'Cutters' },
      { id: 'accesorios-linternas', name: 'Linternas' },
      { id: 'accesorios-espejos', name: 'Espejos Parabólicos' },
      { id: 'accesorios-cintas-antideslizantes', name: 'Cintas Antideslizantes' }
    ]
  }
];

// Mapa de correspondencia ID -> Nombre legible
export const categoryNameMap: Record<string, string> = {};

function buildCategoryNameMap(nodes: CatalogCategoryNode[]) {
  nodes.forEach(node => {
    categoryNameMap[node.id] = node.name;
    if (node.children) buildCategoryNameMap(node.children);
  });
}
buildCategoryNameMap(catalogStructure);

/**
 * Obtiene el nombre legible de una categoría o subcategoría dado su ID.
 */
export const getCategoryName = (id: string): string => {
  return categoryNameMap[id] || id;
};

/**
 * Determina la etiqueta principal representativa de categoría para mostrar en la UI / ProductCard.
 * Evita mostrar 'epp' genérico cuando hay una categoría o subcategoría más específica.
 */
export const getCategoryDisplayLabel = (categoryIds: string[]): string => {
  if (!categoryIds || categoryIds.length === 0) return '';
  
  // Si solo tiene 'epp', devolver 'EPP'
  if (categoryIds.length === 1 && categoryIds[0] === 'epp') {
    return 'EPP';
  }

  // Filtrar 'epp' si hay otros IDs más específicos
  // Preferir primero una subcategoría de nivel 2 (ej. calzado, indumentaria, epp-manos)
  const specificIds = categoryIds.filter(id => id !== 'epp');
  if (specificIds.length === 0) return 'EPP';

  // Buscar el primer ID con nombre en categoryNameMap
  for (const id of specificIds) {
    if (categoryNameMap[id]) {
      return categoryNameMap[id];
    }
  }

  return specificIds[0];
};
